import { render } from "./ssdetail.vue?vue&type=template&id=1fb0d598&scoped=true"
import script from "./ssdetail.vue?vue&type=script&lang=js"
export * from "./ssdetail.vue?vue&type=script&lang=js"

import "./ssdetail.vue?vue&type=style&index=0&id=1fb0d598&lang=scss&scoped=true"
import "./ssdetail.vue?vue&type=style&index=1&id=1fb0d598&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb0d598"]])

export default __exports__